module.exports = __webpack_public_path__ + "img/p12.f482fe9a.png";